/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

// @ts-ignore Allow unused imports
import type * as Types from '../../graphql/schema';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type AdvisorNetworkDisclosureQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdvisorNetworkDisclosureQuery = { __typename: 'Query', disclosures: { __typename: 'Disclosures', advisorNetworkDisclosure: string } };


export const AdvisorNetworkDisclosureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdvisorNetworkDisclosure"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"operationServiceConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feature"},"value":{"kind":"StringValue","value":"AdvisorNetwork","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disclosures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisorNetworkDisclosure"}}]}}]}}]} as unknown as DocumentNode<AdvisorNetworkDisclosureQuery, AdvisorNetworkDisclosureQueryVariables>;